/* eslint-disable */
// @ts-nocheck
import { MICRO_FRONTENDS_CONFIG, MICRO_FRONTEND_VERSIONS } from '../actions/MicroFrontendActions';
import { reducerWrapper } from '../support/utils';
import type { MicroFrontendsReducer } from '../types/microFrontendReducerTypes';
import { BaseMicroFrontendConfig } from '../types/microFrontendReducerTypes';

export const INIT_MICRO_FRONTEND_STATE: BaseMicroFrontendConfig = {
  url: null,
};

export const INIT_STATE: MicroFrontendsReducer = {
  versions: {},
  isLoading: true,
  qlt: INIT_MICRO_FRONTEND_STATE,
  journeysCreativesOptimization: INIT_MICRO_FRONTEND_STATE,
  postbacksForm: INIT_MICRO_FRONTEND_STATE,
  linkManager: INIT_MICRO_FRONTEND_STATE,
  alertNotifications: INIT_MICRO_FRONTEND_STATE,
  qrCodeCustomizations: INIT_MICRO_FRONTEND_STATE,
  usage: INIT_MICRO_FRONTEND_STATE,
  discoDashboard: INIT_MICRO_FRONTEND_STATE,
};

/* eslint-disable @typescript-eslint/default-param-last*/
export function Handler(
  state: MicroFrontendsReducer = INIT_STATE,
  action: {
    type: string;
    data: any;
  }
): MicroFrontendsReducer {
  switch (action.type) {
    case MICRO_FRONTENDS_CONFIG.response:
      return {
        ...state,
        qlt: action?.data?.linkTemplates,
        journeysCreativesOptimization: action?.data?.journeysCreativesOptimization,
        postbacksForm: action?.data?.postbacksForm,
        linkManager: action?.data?.linkManager,
        alertNotifications: action?.data?.alertNotifications,
        qrCodeCustomizations: action?.data?.qrCodeCustomizations,
        usage: action?.data?.usage,
        discoDashboard: action?.data?.discoDashboard,
        isLoading: false,
      };
    case MICRO_FRONTEND_VERSIONS.response:
      return {
        ...state,
        versions: action?.data,
        isLoading: false,
      };
    default:
      return state;
  }
}

const MicroFrontends = reducerWrapper(INIT_STATE, Handler, {
  request: [MICRO_FRONTENDS_CONFIG],
  error: [],
  resetOn: [],
});

export default MicroFrontends;
